<template>
    <div id="addCustomer">
      <a-form :form="customerForm" layout="vertical" v-show="!modeType || isCustomerForm">
        <div class="customerFormDiv">
          <a-row :gutter="20">
            <a-col :span="16">
              <a-form-item class="required" :label="$t('customer.customerModal.companyFullNameLabel')">
                <pt-input @click="addCompany" v-decorator="['companyName',{rules: [
                {required: true,message: $t('customer.customerModal.companyFullNameTip'),},
              ],}]" :placeholder="$t('customer.customerModal.companyFullNameTip')"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('customer.customerModal.companyNameCNLabel')">
                <pt-input  v-decorator="['companySortNameCn',{rules: [
                {required: true,message: $t('customer.customerModal.companyNameCNTip_2'),},
                {validator: validateTextLength,},
              ],}]" :placeholder="$t('customer.customerModal.companyNameCNTip')"  :maxLength="30"></pt-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <!--<a-col :span="7">-->
              <!--<a-form-item :label="$t('customer.customerModal.companyNameENLabel')">-->
                <!--<pt-input  v-decorator="['companySortNameEn',{rules: [-->
                <!--{min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},-->
              <!--],}]" :placeholder="$t('customer.customerModal.companyNameENTip')"></pt-input>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="8">
              <a-form-item   class="required" :label="$t('customer.customerModal.companyTradeLabel')">
                <pt-select   v-decorator="['trade',{rules: [
                {required: true,message: $t('customer.customerModal.companyTradeTip'),},
              ],}]" :placeholder="$t('customer.customerModal.companyTradeTip')">
                  <a-select-option v-for="(trade,index) in tradeList":key="index" :value="trade.wordKey">{{trade.wordValue}}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('customer.customerModal.companyPropertyLabel')">
                <pt-select  v-decorator="['natureOfCompany',{rules:[
                {required: true,message: $t('customer.customerModal.companyPropertyTip'),},
                ]}]" :placeholder="$t('customer.customerModal.companyPropertyTip')">
                  <a-select-option v-for="(nature,index) in natureList":key="index" :value="nature.wordKey">{{nature.wordValue}}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item   class="required" :label="$t('customer.customerList.customerType')">
                <pt-select  :showSearch="true" v-decorator="['customerType',{rules: [
                {required: true,message: $t('customer.customerModal.customerTypeTip'),},
              ],}]" :placeholder="$t('customer.customerModal.customerTypeTip')">
                  <a-select-option v-for="(trade,index) in customerTypeSelects":key="index" :value="trade.wordKey">{{trade.wordValue}}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
          </a-row>
          <!--编辑时不能修改客户关系 v-if="modeType"-->
          <a-row  :gutter="20">
            <a-col v-if='isPersonl' :span="8">
              <a-form-item class="required" :label="$t('customer.customerList.relations')">
                <pt-select  v-decorator="['relations',{rules:[
                {required: true,message: $t('customer.customerModal.relationsTip1'),},
                ]}]" :placeholder="$t('customer.customerModal.relationsTip1')">
                  <a-select-option v-for="(nature,index) in relationsSelects" :key="index" :value="nature.wordKey" :disabled="nature.wordKey == 'Column_A'">{{nature.wordValue}}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <a-col  :span="8">
              <a-form-item  :label="$t('customer.customerList.resource')">
                <a-checkbox class='checkbox' v-model='customerVO.source'  v-decorator="['source']">
                  {{$t('customer.customerList.goldPlan')}}
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
          <!--20200316新增客户简易化，不增加联系人-->
          <div v-if="false">
            <div class="expandMoreBtn" v-if="!contactVisible" @click="toggleContact(true)">
              <pt-icon type="icon-zengjia" class="expandIcon"></pt-icon>
              <div class="expandMoreText">{{$t('track.trackModal.contactLabel')}}</div>
            </div>
            <div class="expandDiv" v-if="contactVisible">
              <div class="expandTitleRow">
                <div class="circleYellow"></div>
                <div class="expandTitle">{{$t('track.trackModal.contactLabel')}}</div>
              </div>
              <div class="expandMoreDiv">
                <div class="closeExpandBtn" @click="toggleContact(false)">
                  <pt-icon type="icon-guanbi-copy" class="closeIcon"></pt-icon>
                </div>
                <a-row>
                  <a-col :span="5">
                    <div class="labelText">{{$t('track.trackModal.contactNameLabel')}}<span style="font-size:14px;color:#f5222d;">*</span></div>
                  </a-col>
                  <a-col :span="5" :offset="1">
                    <div class="labelText">{{$t('track.trackModal.positionLabel')}}</div>
                  </a-col>
                  <a-col :span="5" :offset="1">
                    <div class="labelText">{{$t('track.trackModal.contactNum')}}</div>
                  </a-col>
                  <a-col :span="5" :offset="1">
                    <div class="labelText">{{$t('track.trackModal.contactEmail')}}</div>
                  </a-col>
                </a-row>
                <a-row v-for="(item,index) in contactList" :key="index">
                  <a-col :span="5">
                    <a-form-item>
                      <pt-input  v-decorator="[`linkmanDOList[${index}].name`,{rules: [
                {required: true,message: $t('customer.customerModal.contactNameTip'),},
              ],}]" :placeholder="$t('track.trackModal.contactNameTip')"></pt-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" :offset="1">
                    <a-form-item>
                      <a-input  v-decorator="[`linkmanDOList[${index}].job`,{rules: [
               {min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},
              ],}]" :placeholder="$t('track.trackModal.positionTip')"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" :offset="1">
                    <a-form-item>
                      <a-input  v-decorator="[`linkmanDOList[${index}].phone`,{rules: [
                {min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},
              ],}]" :placeholder="$t('track.trackModal.contactNum')"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" :offset="1">
                    <a-form-item>
                      <a-input  v-decorator="[`linkmanDOList[${index}].email`,{rules: [
                {
                  type: 'email',
                  message:$t('customer.customerModal.emailErrorTip'),
                },
                {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
              ],}]" :placeholder="$t('track.trackModal.contactEmail')">
                      </a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="1">
                    <div class="deleteBtn" @click="deleteContactRow(index)">
                      <pt-icon type="icon-tubiao" class="delIcon"></pt-icon>
                    </div>
                  </a-col>
                </a-row>
                <a-row>
                  <div class="addBtn" @click="addContactRow">
                    <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                  </div>
                </a-row>
              </div>
            </div>
          </div>
      </div>
      </a-form>
      <search-company ref="searchInnerCompany" @confirm="confirmSelect" v-show="modeType && !isCustomerForm"></search-company>
      <pt-modal :width="800" :title="$t('customer.searchCompanyModal.title')" :visible="searchCustomerModel.visable" :loading="searchCustomerModel.loading"
                @ok="submitEvent" @cancel="cancelEvent">
        <div slot="content">
          <search-company ref="searchCompany" @confirm="confirmSelect"></search-company>
        </div>
      </pt-modal>
    </div>
</template>

<script>
  import {getDatadictChildsByPath} from '@/api/sys/datadict';
  import {insert,update,selectOne} from '@/api/mine/customer';
  import OssUpload from "../../../../components/upload/ossUpload";
  import SearchCompany from './searchCompany';
  export default {
    components: {OssUpload,SearchCompany},
    name: 'addCustomer',
    props:{
      customerId: null,
      modeType:{ //true 为新增 false 为编辑
        default:true,
        type:Boolean
      },
      value:{

      },
      isPersonl: {
        type:Boolean,
        default:true,
      },
    },
    data(){
      return{
        isCustomerForm:false,
        contactVisible:false,
        customerForm: this.$form.createForm(this,{}),
        contactList:[],
        activeLabel:1,
        labelList:[],//客户标签属性
        tradeList:[],//客户行业设置
        natureList:[],//性质
        labelOptions:[],//
        fileDO:{
          id:"0"
        },//logo信息
        labelStr:[],//客户标签
        customerVO:{},//客户详情信息
        searchCustomerModel:{
          visable:false,
          loading:false,
        },
        company:{},//选中公司信息
        relationsSelects:[],
        customerTypeSelects:[],
      }
    },
    beforeCreate () {
      this.customerForm = this.$form.createForm(this)
    },
    mounted(){
      this.$emit('input',this.$t('customer.searchCompanyModal.title'));//
      this.init()
    },
    methods:{
      toggleContact(visible){
        this.contactVisible = visible;
        if(visible){
          this.addContactRow()
        }else{
          this.contactList = []
        }
      },
      strlen(str){
        var len = 0;
        for (var i=0; i<str.length; i++) {
          var c = str.charCodeAt(i);
          //单字节加1
          if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {
            len++;
          }
          else {
            len+=2;
          }
        }
        return len;
      },
      validateTextLength(rule, value, callback){
        if(value){
          let length = this.strlen(value)
          if (length > 30) {
            callback("15个中文或30个英文的字节长度")
          } else if (value == 0) {
            callback("请输入公司简称")
          }else{
            callback()
          }
        } else {
          callback()
        }
      },
      confirmSelect(company){
        this.company = company;
        this.customerForm.setFieldsValue({
          companyName: company.name
        })
        if(this.modeType){
          this.isCustomerForm = true;
          this.cancelEvent();
        }else{
          this.cancelEvent();
        }

      },
      cancelEvent(){
        this.searchCustomerModel.visable = false;
      },
      submitEvent(){
        this.$refs.searchCompany.confirmSelect();
      },
      addCompany(){
        if(this.modeType){
          this.searchCustomerModel.visable = true;
        }else{
          this.searchCustomerModel.visable = true;
        }
      },
      getImageUrl(){
        let url = this.$util.getFileUrl(this.fileDO.id);
        return url;
      },
      init(){
        this.queryLabelList();
        this.queryTradeList();
        this.queryNatureList();
        this.getCustomerTypeSelects();
        this.getRelationsSelects();
        if(this.customerId){
          this.queryCustomerDetail();
        }else{
          this.initCustomerForm();
        }
      },
      initCustomerForm(){
        this.customerForm.setFieldsValue({
          relations:'D',
          natureOfCompany:'chinese',
          customerType:'1',
        })
      },
      queryCustomerDetail(){
        let this_ = this
        selectOne(this_.customerId).then(res=>{
          if(res.code == 1){
            let temp = JSON.stringify(res.data)
            this_.customerVO = JSON.parse(temp.replace(/\"~\"/g,null))
            console.log(" this_.customerVO-================", this_.customerVO.source)
            if (this.customerVO.natureOfCompany == null){
              this.customerVO.natureOfCompany = 'chinese';
            }
            if (this.customerVO.trade == null){
              this.customerVO.trade = undefined;
            }
            if (this.customerVO.relations == null && this.isPersonl ){
              this.customerVO.relations = 'D';
            }
            if ( this_.customerVO.source == 1 ){
              this.customerVO.source = true;
            }

            let tradeList_ = [];
            this.tradeList.forEach(e=>{
              tradeList_.push(e.wordKey)
            })
            this.customerVO.trade = tradeList_.find(e=> e ==this.customerVO.trade)
            this_.fillForm();
          }
        })
      },
      fillForm(){
        this.fileDO.id = this.customerVO.logo;
        if(this.customerVO.labelStr != '~' && this.customerVO.labelStr){
          this.labelStr = JSON.parse(this.customerVO.labelStr);
          if(this.labelStr.length > 0){
            let curLabelStr = this.labelStr.join(',');
            this.labelOptions.forEach(e=>{
              if(curLabelStr.indexOf(e.value+'') >= 0){
                e.isActive = true;
              }else{
                e.isAcitve = false;
              }
            })
          }
        }
        // if(this.customerVO.linkmanDOList.length > 0){
        //   this.contactList = [];
        //   this.customerVO.linkmanDOList.forEach((data,index)=>{
        //     this.contactList.push(index);
        //   })
        // }
        console.log("当前数据",this.customerVO)
        setTimeout(()=>{

          this.customerForm.setFieldsValue(this.customerVO);
        },0)
      },
      queryLabelList(){
        // let this_ = this
        // getDatadictChildsByPath("system.business_key.compay_lable_set").then(res=>{
        //   this_.labelList = res.data
        //   this_.labelCheckOptions();
        // })
      },
      getCustomerTypeSelects(){
        getDatadictChildsByPath("system.business_key.customer_type").then(res=>{
          this.customerTypeSelects = res.data
        })
      },
      getRelationsSelects(){
        getDatadictChildsByPath("system.business_key.relation").then(res=>{
          this.relationsSelects = res.data
        })
      },
      onSuccess(file,fileId,number){
        this.fileDO = Object.assign(file,{id:fileId});
      },
      selectLabel(item){
        item.isActive = !item.isActive;
      },
      getLabelArr(){
        this.labelStr = [];
        this.labelOptions.forEach((item,index) => {
          if(item.isActive){
            this.labelStr.push(item.value)
          }
        });
      },
      labelCheckOptions(){
        this.labelList.forEach(item=>{
          let option = {
            label:item.wordValue,
            value:item.wordKey,
            isActive:false
          }
          this.labelOptions.push(option);
        })
      },
      queryTradeList(){
        let this_ = this
        getDatadictChildsByPath("system.mansion_set.trade_set").then(res=>{
          this_.tradeList = res.data
        })
      },
      queryNatureList(){
        let this_ = this
        getDatadictChildsByPath("system.business_key.nature_of_company").then(res=>{
          this_.natureList = res.data
        })
      },
      deleteContactRow(index){
        this.contactList.splice(index,1);
      },
      addContactRow(){
        this.contactList.push(1);
      },
      submit(){
        if(this.modeType && !this.isCustomerForm){
          this.$refs.searchInnerCompany.confirmSelect();
          this.$emit('input',this.$t('track.trackModal.addCustomer'))
        }else{
          this.customerForm.validateFieldsAndScroll({force:true},(err, values) => {
            if (!err) {
              console.log("values",values)
              this.fillData(values);
            }else{
              this.$emit("error");
            }
          });
        }
      },
      fillData(data){
        this.getLabelArr();
        if(this.customerId){
          data["id"] = this.customerId;
          console.log("data-=-=-=",data)
          console.log("data-=relations-=-=",data["relations"])
          if (data["relations"] == undefined){
            data["relations"] = this.customerVO.relations;
          }


          data["version"] = this.customerVO.version;
          if(this.company.keyNo){
            data["keyNo"] = this.company.keyNo;
          }else{
            if(this.customerVO.keyNo){
              data["keyNo"] = this.customerVO.keyNo;
            }
          }
        }else{
          data["keyNo"] = this.company.keyNo;
        }
        data["logo"] = this.fileDO.id;
        data["labelStr"] = this.labelStr;
        if(this.customerId){
          this.updateCustomer(data);
        }else{
          this.addCustomer(data);
        }
      },
      addCustomer(data){
        insert(data).then(res => {
          if (res.code == 1) {
            let companySortNameCn = this.customerForm.getFieldValue('companySortNameCn')
            data['companySortNameCn'] = companySortNameCn
            this.$message.success(this.$t('customer.customerModal.saveSuccessTip'));
            this.$emit("saveSuccess",res.data,data.companyName,data);
          }else{
            this.$emit("error")
          }
        })
      },
      updateCustomer(data){
        console.log("data-----",data)
        update(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('customer.customerModal.updateSuccessTip'));
            this.$emit("saveSuccess");
          }else{
            this.$emit("error")
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #addCustomer{
    .checkbox{
      padding-top: 10px;
      padding-left: 5px;
    }
    .statusSelected{
      border: 1px solid #FABE00;
      transition: background-color .15s ease-in-out;
      background: #FABE00;
      border-radius: 4px;
      /*width: 90px;*/
      padding: 0 12px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      cursor: pointer;
      margin-right: 12px;
      margin-bottom: 10px;
    }
    .statusDefault{
      border: 1px solid #EAEAEA;
      transition: background-color .15s ease-in-out;
      background: #FFFFFF;
      border-radius: 4px;
      /*width: 90px;*/
      padding: 0 12px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      cursor: pointer;
      margin-right: 12px;
      margin-bottom: 10px;
    }
    .deleteBtn{
      margin-top: 10px;
      margin-left: 10px;
      cursor: pointer;
      .delIcon{
        font-size: 18px;
      }
    }
    .addBtn{
      width: 20px;
      height: 16px;
      border: 1px solid #FABE00;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-bottom: 18px;
      .addIcon{
        font-size: 12px;
        color: #FABE00;
      }
    }
    .labelText{
      font-size: 12px;
      color: #999999;
      margin-left: 4px;
    }
    .customerFormDiv{
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      padding: 20px;
      margin-bottom: 20px;
    }
    .noContactDiv{
      color: #999999;
      font-size: 12px;
      text-align: center;
      padding: 20px;
    }
    .titleRow{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 5px;
      .circle{
        margin-left: 12px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #FABE00;
      }
      .titleText{
        padding: 0 10px;
        color: #333333;
        font-size: 14px;
      }
    }
    .uploadText{
      font-size: 12px;
      color: #999999;
      margin-bottom: 5px;
    }
    .uploadImageDiv{
      width: 90px;
      height: 90px;
      background: #E3E3E3;
      border: 1px solid #D3D3D3;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .addIcon{
        font-size: 18px;
        color: #454341;
      }
    }
    .labelDiv{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .labelItemActive{
      cursor: pointer;
      background: #FABE00;
      border-radius: 4px;
      width: 90px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      margin-right: 28px;
      margin-top: 14px;
    }
    .labelItem{
      cursor: pointer;
      background: #FFFFFF;
      border: 1px solid #EAEAEA;
      border-radius: 4px;
      width: 90px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #333333;
      margin-right: 28px;
      margin-top: 14px;
    }
    .expandMoreBtn{
      background: #E8E8E8;
      border: 1px solid #DFDFDF;
      border-radius: 2px;
      height: 25px;
      display: inline-block;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      cursor:pointer;
      margin-bottom: 5px;
      margin-top: 20px;
      .expandIcon{
        font-size: 12px;
      }
      .expandMoreText{
        display: inline;
        margin-left: 5px;
        font-size: 12px;
        color: #666666;
      }
    }
    .expandDiv{
      margin-top: 20px;
      .expandMoreDiv{
        padding: 20px 10px 0px 10px;
        background: #F2F4F6;
        border-radius: 2px;
        position: relative;
      }
      .closeExpandBtn{
        position: absolute;
        right: 0px;
        top:0px;
        width: 24px;
        height: 24px;
        border-radius:2px;
        background: #D3D3D3;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        .closeIcon{
          font-size: 14px;
          color: #FFFFFF;
        }
      }
      .expandTitleRow{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 5px;
        .circleYellow{
          width: 12px;
          height: 12px;
          background: #FABE00;
          border-radius: 50%;
          margin-right: 10px;
        }
        .expandTitle{
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }
</style>